import React from "react";
import { Box } from "@chakra-ui/react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin, { DateClickArg } from "@fullcalendar/interaction";
import { TimeSlot } from "../types";

interface BookingCalendarProps {
  availableSlots: TimeSlot[];
  onDateSelect: (date: Date) => void;
}

const BookingCalendar: React.FC<BookingCalendarProps> = ({
  availableSlots,
  onDateSelect,
}) => {
  // Create events for the calendar
  const events = availableSlots.map((slot) => ({
    start: new Date(slot.startTime),
    end: new Date(slot.endTime),
    display: "background",
    backgroundColor: "#90CDF4",
  }));

  // Get unique dates that have available slots
  const availableDates = new Set(
    availableSlots.map((slot) => new Date(slot.startTime).toDateString())
  );

  // Custom day cell render to highlight days with available slots
  const handleDayCellDidMount = (info: any) => {
    const dateStr = info.date.toDateString();
    if (availableDates.has(dateStr)) {
      info.el.style.backgroundColor = "#EBF8FF";
    }
  };

  // Handle date click
  const handleDateClick = (arg: DateClickArg) => {
    onDateSelect(arg.date);
  };

  return (
    <Box mb={6}>
      <div className="calendar-container">
        <FullCalendar
          plugins={[dayGridPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          height="auto"
          events={events}
          dayCellDidMount={handleDayCellDidMount}
          dateClick={handleDateClick}
          headerToolbar={{
            left: "prev,next today",
            center: "title",
            right: "",
          }}
        />
      </div>
    </Box>
  );
};

export default BookingCalendar;
